import { useEffect, useState } from 'react';

const config = {
  root: null,
  rootMargin: '0px',
  threshold: 0,
};

const useObserver = ({ ref, options, removeAfterInView = false }) => {
  const [isElementInView, setElementInView] = useState(false);

  useEffect(() => {
    if (!ref?.current) return; // Skip if ref is not valid

    const observer = new IntersectionObserver(
      ([entry]) => {
        setElementInView(entry.isIntersecting);

        // Unobserve if the element is in view and `removeAfterInView` is true
        if (entry.isIntersecting && removeAfterInView) {
          observer.unobserve(ref.current);
        }
      },
      { ...config, ...options }
    );

    // Safely observe the element
    if (ref.current) {
      observer.observe(ref.current);
    }

    // Cleanup the observer
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, options, removeAfterInView]);

  return isElementInView;
};

export default useObserver;
